'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _ramda = require('ramda');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable*/

var IntradayChart = function (_React$Component) {
  _inherits(IntradayChart, _React$Component);

  function IntradayChart(props) {
    _classCallCheck(this, IntradayChart);

    var _this = _possibleConstructorReturn(this, (IntradayChart.__proto__ || Object.getPrototypeOf(IntradayChart)).call(this, props));

    _this.trackChartHover = false;
    return _this;
  }

  _createClass(IntradayChart, [{
    key: 'createIntradayChart',
    value: function createIntradayChart(printWidth) {
      var data = this.props.intradayNavData;
      var isDesktop = this.props.breakpoint > 3;
      var endDate = data[data.length - 1].date;
      var xAxisTicks = [];
      if (_chart_utility2.default.isInputDateLessThanSixMonthOld(this.props.shareClassInceptionDate)) {
        var oneDayAfterInceptionDate = (0, _moment2.default)(this.props.shareClassInceptionDate).add(1, "days");
        oneDayAfterInceptionDate = oneDayAfterInceptionDate.format('YYYY-MM-DD');
        xAxisTicks = _chart_utility2.default.createXAxisTicksForLessThanSixMonthOldFund(oneDayAfterInceptionDate, isDesktop);
      } else {
        xAxisTicks = _chart_utility2.default.createXAxisTicks(endDate, isDesktop);
      }

      var intradayTimeColors = void 0;
      if (data[0]._3pmNAVPrice > 0) {
        intradayTimeColors = ["transparent", "transparent", "#006496", "transparent"];
      } else {
        intradayTimeColors = ["transparent", "#006496", "transparent", "transparent"];
      }
      var self = this;
      var spec = (0, _ramda.mergeDeepLeft)({
        "container": {
          "rangePaddingRight": 50,
          "marginBottom": 50,
          "marginLeft": 50,
          "marginRight": 20
        },
        "keys": ["date"],
        "values": ["_8amNAVPrice", "_12pmNAVPrice", "_3pmNAVPrice", "_3pmNAVTime"],
        "type": "line",
        "style": {
          "fill": intradayTimeColors
        },
        "axis": {
          "x": {
            "show": true,
            "label": {
              "show": true,
              "text": function text(d) {
                return d3.timeFormat("%m/%d/%Y")(d);
              }
            },
            "tick": {
              "padding": 5,
              "values": xAxisTicks
            },
            "domain": [xAxisTicks[0], xAxisTicks[xAxisTicks.length - 1]]
          },
          "y": {
            "show": true,
            "domain": [0.9970, 1.0025],
            "label": {
              "show": true,
              "text": function text(d) {
                if (d === 0.9970) {
                  return "";
                } else {
                  return d3.format(",.4f")(d);
                }
              }
            },
            "tick": {
              "padding": 5,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            },

            "tickValues": [0.9970, 0.9975, 0.9980, 0.9985, 0.9990, 0.9995, 1.000, 1.0005, 1.0010, 1.0015, 1.0020, 1.0025]
          }
        },
        "hoverLine": {
          "tooltip": {
            "text": function text(data) {
              if (!self.trackChartHover) {
                _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
                  "eventAction": "share class market-based nav chart",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
                });
                self.trackChartHover = true;
              }
              var tooltiptext = "<div style= 'text-align:left'>";
              var tooltipTextNavPrice = "";

              for (var prop in data) {
                if (prop === "date") {
                  tooltiptext += "<div class='caption' style='font-weight:100'>" + _date_formatter2.default.getDateInESTFormat(data[prop]) + "</div>";
                } else {
                  if (data[prop] > 0) {
                    tooltipTextNavPrice = "<div><span class='caption' style='font-weight: 400'>" + parseFloat(data[prop]).toFixed(4) + "</span></div>";
                  }
                }
              }
              tooltiptext += tooltipTextNavPrice;
              tooltiptext += "</div> ";
              return tooltiptext;
            }
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (printWidth && typeof printWidth === "number") {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }

      return (0, _chart_utility.generateChart)((0, _chart_utility3.generateChartId)("IntradayNAVChart", printWidth && typeof printWidth === "number"), "linechart", data, spec);
    }
  }, {
    key: 'render',
    value: function render() {
      var intradayNavChart = this.createIntradayChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(intradayNavChart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createIntradayChart(800))
        )
      );
    }
  }]);

  return IntradayChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = IntradayChart;